/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LeadInputs */

const cs_field_lead = /** @type {(inputs: Field_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

const en_field_lead = /** @type {(inputs: Field_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

/**
* | output |
* | --- |
* | "Lead" |
*
* @param {Field_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_lead = /** @type {((inputs?: Field_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_lead(inputs)
	return cs_field_lead(inputs)
});